export default {
  inputWithOptions: 'autocomplete-with-label-input-wrapper',
  inputWithLabel: 'autocomplete-with-label-input',
  label: 'autocomplete-with-label-labelled-label',
  labelledElement: 'autocomplete-with-label-labelled-element',
  inputDropdownLayout: 'inputwithoptions-dropdownlayout',
};
